import React from 'react'



export default function Certification(props) {


  return (
    <>
   
 
    <div>
        <h3>{props.title}</h3>
        <h4 id='org-name' ><span><strong id='org-name2'>Organization</strong></span>{props.org}</h4>
        <h5 ><span><strong>Date</strong></span>{props.date}</h5>
       <a href={props.link}> <button className='certification_button'>View My Certificate</button></a>
        </div>
       
        </>
  )
}